<i *ngIf="icon" [uiType]="icon" ui-icon></i>
<ng-container *nzStringTemplateOutlet="template">{{ template }}</ng-container>
<ng-content></ng-content>
